import { render, staticRenderFns } from "./ProductSamplingView.vue?vue&type=template&id=3cb68b96&scoped=true"
import script from "./ProductSamplingView.vue?vue&type=script&lang=js"
export * from "./ProductSamplingView.vue?vue&type=script&lang=js"
import style0 from "./ProductSamplingView.vue?vue&type=style&index=0&id=3cb68b96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb68b96",
  null
  
)

export default component.exports